<span 
  class="jit-tag"
  [class.default]="type === Tags.DEFAULT"
  [class.success]="type === Tags.SUCCESS"
  [class.error]="type === Tags.ERROR"
>
  {{ label }}
</span>